CheckoutV2.PaymentV2.WireTransfer = function(checkout, $container) {
    var method = this;

    this._init = function() {
        var fee = __fixDecimals(checkout.config.wireTransferFee);
        var cartTotal = __fixDecimals(checkout.cart.totals.values.total);
        method._render(fee);
        method.setNextStepButtonHtml();
        method._setPaymentActiveMethods(cartTotal + fee);
        checkout.payment.onMethodValid();
    };

    this._render = function(fee) {
        var data = { fee: fee.toMoney() };
        var $content = $($.parseHTML(Jemplate.process('includes/partials/payment/wireTransfer.html', data)));
        $container.find('.payment-method-wiretransfer-container').html($content);
        $container.find('.collapse').addClass('show');
    };

    // Sets the payment modules active methods
    this._setPaymentActiveMethods = function(amount){
        var paymentMethod = checkout.payment.models.paymentMethodFromWireTransfer(amount);
        checkout.payment.setActivePaymentMethods([paymentMethod]);
    };

    // Called by checkout and the method to set the next step button text
    this.setNextStepButtonHtml = function() {
        checkout.payment.setNextStepCTA(checkout.getReviewStepCTA());
        checkout.payment.setNextStepButtonHtml(checkout.getReviewStepButtonHtml());
    };

    this._init();
};